<div class="content-card">
  <div class="card-inner">
    <p-fluid>
      <div class="font-semibold text-xl mb-4 module-name">
        Test Recordings
      </div>

      <!-- Filter Dropdowns -->
      <div class="flex gap-3 mb-4">
        <div class="flex-1">
          <label for="filterClient" class="block mb-2">Client</label>
          <p-select id="filterClient" [options]="viewModel.clientOptions" [(ngModel)]="viewModel.filterClient"
            optionLabel="name" optionValue="id" placeholder="Select Client"
            [showClear]="!!viewModel.filterClient && viewModel.filterClient !== 'default' && !viewModel.isClientFilterDisabled"
            [disabled]="viewModel.isClientFilterDisabled"
            (onChange)="viewModel.onClientFilterChange()" class="w-full"></p-select>
        </div>
        <div class="flex-1">
          <label for="filterPackage" class="block mb-2">Package</label>
          <p-select id="filterPackage" [options]="viewModel.packageOptions" [(ngModel)]="viewModel.filterPackage"
            optionLabel="packageName" optionValue="id" placeholder="Select Package"
            [showClear]="!!viewModel.filterPackage" (onChange)="viewModel.onPackageFilterChange()" class="w-full"></p-select>
        </div>
        <div class="flex-1">
          <label for="filterTestType" class="block mb-2">Test Type</label>
          <p-select id="filterTestType" [options]="viewModel.filteredTestTypeOptions"
            [(ngModel)]="viewModel.filterTestType" (onChange)="viewModel.onTestTypeFilterChange()"
            optionLabel="referenceValue" optionValue="id" placeholder="Select Test Type"
            [showClear]="!!viewModel.filterTestType"
            [disabled]="!viewModel.filterClient"
            class="w-full"></p-select>
        </div>
        <div class="flex-1">
          <label for="filterFunctionalArea" class="block mb-2">Functional Area</label>
          <p-select id="filterFunctionalArea" [options]="viewModel.functionalAreaOptionsWithTestType"
            [(ngModel)]="viewModel.filterFunctionalArea" optionLabel="displayName" optionValue="id"
            placeholder="Select Functional Area" [showClear]="!!viewModel.filterFunctionalArea"
            [disabled]="false"
            (onChange)="viewModel.onFilterChange()"
            class="w-full" [filter]="true" filterBy="displayName"></p-select>
        </div>
      </div>

      <!-- Recordings Table -->
      <p-table #dt [value]="viewModel.filteredRecordings" [rows]="viewModel.pageSize" [paginator]="true"
        [lazy]="true" (onLazyLoad)="viewModel.onLazyLoad($event)" [totalRecords]="viewModel.totalRecordings"
        [tableStyle]="{ 'min-width': '75rem' }" [rowHover]="true" dataKey="id"
        currentPageReportField="Showing {first} to {last} of {totalRecords} recordings" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 20, 30]">

        <ng-template #caption>
          <div class="flex items-center justify-between">
            <h5 class="m-0"></h5>
            <div class="flex flex-col items-end gap-3">
              <p-button label="Add" icon="pi pi-plus" severity="info" *ngIf="viewModel.isSystemUser()"
                (click)="viewModel.openRecorder()" />
              <div class="search-container">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (input)="viewModel.onGlobalFilter(dt, $event)"
                    placeholder="Search..." />
                </span>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th style="min-width: 10rem">
              Package
            </th>
            <th style="min-width: 16rem">
              Functional Area
            </th>
            <th style="min-width: 16rem">
              Test Type
            </th>
            <th pSortableColumn="runName" style="min-width:16rem">
              Scenario Name
            </th>
            <th style="min-width: 20rem">
              Description
            </th>
            <th style="width: 12rem">Action</th>
          </tr>
        </ng-template>

        <ng-template #body let-recording>
          <tr>
            <td style="min-width: 10rem">
              {{ recording.packageDefinition?.packageName || '-' }}
            </td>
            <td style="min-width: 16rem">
              {{ recording.functionalArea?.name || '-' }}
            </td>
            <td style="min-width: 16rem">
              {{ recording.testType?.referenceValue || '-' }}
            </td>
            <td style="min-width: 16rem">
              {{ recording.runName }}
            </td>
            <td style="min-width: 20rem">
              {{ recording.description || '-' }}
            </td>
            <td style="width: 12rem">
              <p-button icon="pi pi-pencil" severity="info" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.editRecording(recording)" pTooltip="Edit" tooltipPosition="top" class="mr-2" />
              <p-button icon="pi pi-copy" severity="secondary" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.cloneRecording(recording)" pTooltip="Clone" tooltipPosition="top" class="mr-2" />
              <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.deleteRecording(recording)" pTooltip="Delete" tooltipPosition="top" />
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="6" class="noData">No recordings found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-fluid>
    <p-confirmdialog [style]="{ width: '450px' }" />
  </div>
</div>